import { Injectable } from '@angular/core';
import { ConfiguracionInicialService } from './configuracioninicial.service';
import { ComunicacionapiService } from './comunicacionapi.service';
import { Constantes } from '../models/modules/Constantes';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class RecaudosService {
  
  constructor(private configInicial: ConfiguracionInicialService,
    private comunicacionapiService: ComunicacionapiService) {
      
  }

  ConsultarAliados(): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.RECAUDOS_CONSULTARALIADOS()}`;
    return this.comunicacionapiService.Get(urlServicio);
  }
  ConsultarProgramas(idAliado: number): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.RECAUDOS_CONSULTARPROGRAMA()}${idAliado}`;
    return this.comunicacionapiService.Get(urlServicio);
  }
  ConsultarRecaudosPendientes(): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.RECAUDOS_CONSULTARRECAUDO_PENDIENTES()}`;
    return this.comunicacionapiService.Get(urlServicio);
  }
  ConsultarRecaudos(idAliado: number, idPrograma: number): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.RECAUDOS_CONSULTARRECAUDO()}${idAliado}/${idPrograma}`;
    return this.comunicacionapiService.Get(urlServicio);
  }
  GenerarRecaudos(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.RECAUDOS_GENERAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  AnularRecaudos(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.RECAUDOS_ANULAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  RespuestaRecaudos(archivo: any, idAplicacion: number, idPrograma: number, idRecaudo: number): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.RECAUDOS_RESPUESTA()}${idAplicacion}/${idPrograma}/${idRecaudo}`;
    return this.comunicacionapiService.Post(urlServicio, archivo);
  }
  DescargarArchivoGeneradoRecaudos(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.RECAUDOS_DESCARGARARCHIVOGENERADO()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  DescargarRespuestaRecaudos(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.RECAUDOS_DESCARGARRESPUESTA()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  MarcarCompletadoRecaudo(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.RECAUDOS_MARCARCOMPLETO()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
}
